import { render, staticRenderFns } from "./TicketTable.vue?vue&type=template&id=3bcf8f91&"
import script from "./TicketTable.vue?vue&type=script&lang=ts&"
export * from "./TicketTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports